import Styles from "./Mob.module.css"
import { Grid2,Typography } from "@mui/material"
import pic from "../../../ui-utils/latestPics/PlatformApi.svg"
import en from "../../../i18n/English/Api/home.json";
import hi from "../../../i18n/Hindi/Api/home.json";
import kn from "../../../i18n/Kannada/Api/home.json";
import ma from "../../../i18n/Marathi/Api/home.json";
import gu from "../../../i18n/Gujarati/Api/home.json";
import { useLanguage } from "../../../Context/LangContext";
export default function MobApi() {
    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language];
    return (
        <>
            <Grid2 className={Styles.outerCard}>


                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <h1 className={Styles.firstQue} style={{ fontWeight: 600 }}>
                        {t.questions[0].question}
                    </h1>
                </div>
                        <Typography className={Styles.subTxt}>
                    {t.questions[0].answer}


                        </Typography>

                        <h1 className={Styles.secondQue}>
                    {t.questions[1].question}
                        </h1>
                        <Typography className={Styles.subTxt1}>
                    {t.questions[1].answer}
                        </Typography>


                    <img src={pic} alt="AlgoTradingLogo" className={Styles.pic} />

                </Grid2>


        </>
    )
}